import { calculateRideMetrics, compileRideProgress, type RidePoint } from './ride';

/** Temporary display assumptions requested for the Manhattan demo, never recording data. */
export const STRUCTURES_DEMO_TELEMETRY = {
  version: 1,
  speedKilometersPerHour: { center: 4.8, slowVariation: .65, fastVariation: .35 },
  // Gentle southbound terrain approximation, meters above sea level, by path distance.
  elevationAnchors: [[0, 16], [.16, 27], [.34, 14], [.5, 10], [.68, 18], [.85, 7], [1, 4]],
} as const;

/** Derives display-only times and heights while retaining every horizontal path coordinate. */
export function structuresDemoTelemetry(points: readonly RidePoint[]) {
  const route = compileRideProgress(points);
  const start = Date.parse(points[0]!.recordedAt);
  let elapsedSeconds = 0;
  const samples = points.map((point, index) => {
    const fraction = route.distanceFractions[index]!;
    if (index) {
      const midpoint = (fraction + route.distanceFractions[index - 1]!) / 2;
      const pace = STRUCTURES_DEMO_TELEMETRY.speedKilometersPerHour;
      const speed = pace.center + pace.slowVariation * Math.sin(midpoint * 6 * Math.PI)
        + pace.fastVariation * Math.sin(midpoint * 19 * Math.PI);
      elapsedSeconds += (fraction - route.distanceFractions[index - 1]!) * route.totalDistanceKilometers / speed * 3600;
    }
    const anchors = STRUCTURES_DEMO_TELEMETRY.elevationAnchors;
    const end = anchors.findIndex(anchor => anchor[0] >= fraction);
    const after = anchors[Math.max(0, end)]!;
    const before = anchors[Math.max(0, end - 1)]!;
    const mix = after[0] === before[0] ? 0 : (fraction - before[0]) / (after[0] - before[0]);
    const elevationMeters = before[1] + (after[1] - before[1]) * (1 - Math.cos(mix * Math.PI)) / 2;
    return { ...point, elevationMeters, recordedAt: new Date(start + elapsedSeconds * 1000).toISOString() };
  });
  return { points: samples, metrics: calculateRideMetrics(samples), available: true };
}
